export default __webpack_public_path__ + "static/nodata-238a039386758a227094c0a63c3f0af6.png";